export enum EBlockTypes {
  REGULATORY_UPDATE = 'REGULATORY_UPDATE',
  QUALIFIED_INVESTOR = 'QUALIFIED_INVESTOR',
  PROFESSIONAL_INVESTOR = 'PROFESSIONAL_INVESTOR'
}
